import React from 'react';
import { Box, makeStyles, Theme, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../redux/redux-store';
import { ContactUs } from './components/ContactUs';
import { ReferralSideBar } from '../../../../components/ReferralSideBar';
import { SideBar } from '../../../../components/SideBar';
import { TopBar } from '../../../../components/TopBar';
import { ROLES } from '../../../../shared/globals';

export const SupportPage = () => {
  const classes = useStyles();
  const logedUser: any = localStorage.getItem('formFlash');
  const loggedInUser = JSON.parse(logedUser);

  const success: any = useSelector((state: RootState) => state.DISPLAY_STATE_REDUCER.displaySuccess.createCollectionSuccess);

  return (
    <Box className={classes.main} display="flex" flexDirection="column" p={4}>
      <Box mb={4}>
        <TopBar />
      </Box>
      {loggedInUser && loggedInUser.role === ROLES.REFERRAL ?
        <Grid container>
          <Grid item xs={12}>
            <ContactUs />
          </Grid>
        </Grid> :
        <Grid container>
          <Grid item xs={12} sm={2} md={2}>
            {loggedInUser && (loggedInUser.role === 'SITE_ADMIN' || loggedInUser.role === 'BUILDER' || loggedInUser.role === ROLES.CLINICIAN || loggedInUser.role === ROLES.PATIENT || loggedInUser.role === ROLES.PROXY || loggedInUser.role === ROLES.RATER) ? <SideBar /> : <ReferralSideBar />}
          </Grid>
          <Grid item xs={12} sm={10} md={10}>
            <ContactUs />
          </Grid>
        </Grid>}
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    [theme.breakpoints.down('xs')]: {
      padding: '1rem'
    },
    backgroundColor: theme.background.main,
    minHeight: '100vh'
  },
  contentContainer: {
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    }
  }
}));
